module.exports = __webpack_public_path__ + "static/media/SF-18-A.b8434757.mp3";